module.exports = __webpack_public_path__ + "static/media/jack-o-lantern.03de72d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/jack-o-lantern.png
// module id = 6384
// module chunks = 0